module.exports = __webpack_public_path__ + "img/logo2.cfa6b3b6.png";